import { render } from "./modal-bottom-tiered-points.html?vue&type=template&id=aa616888&scoped=true&ts=true"
import script from "./modal-bottom-tiered-points.vue?vue&type=script&lang=ts"
export * from "./modal-bottom-tiered-points.vue?vue&type=script&lang=ts"

import "./modal-bottom-tiered-points.scss?vue&type=style&index=0&id=aa616888&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa616888"]])

export default __exports__